import { useEffect } from 'react';
import { useOffers } from 'components/Signup/hooks/useOffers';
import { useAmplitude } from 'hooks/useAmplitude';
import { useGetIntroducerApplication } from 'lendingApi/lendingApiHooks';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';

export const useDETradingHistoryPage = () => {
  const { trackEvent } = useAmplitude();
  const { application } = useGetIntroducerApplication();

  const {
    isLoadingOffers,
    isRefetchingOffers,
    offers,
    signupError,
    hasSignupDecision,
    isErrorChecked,
    setIsErrorChecked,
    isSecurityCheckRequired,
    handleRedirect,
    documentRequirements,
  } = useOffers({
    getOffersEnabled: true,
  });

  useEffect(() => {
    setIsErrorChecked(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const requestedDuration = application?.requested_products?.[0].duration;
  const requestedAmount = application?.requested_products?.[0].amount;

  useEffect(() => {
    trackEvent(AMPLITUDE_EVENTS.applicationTradingHistoryAndOffersPending);

    const hasDataAvailable =
      !isLoadingOffers &&
      !isRefetchingOffers &&
      isErrorChecked &&
      !signupError &&
      !isSecurityCheckRequired;

    if (offers && hasDataAvailable) {
      handleRedirect(offers);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isLoadingOffers,
    isRefetchingOffers,
    offers,
    signupError,
    isErrorChecked,
    isSecurityCheckRequired,
  ]);

  const isLoadingOffersAndRelatedData =
    !offers ||
    isLoadingOffers ||
    isRefetchingOffers ||
    !isErrorChecked ||
    !hasSignupDecision;

  const isLoadingPage =
    isLoadingOffers || (isRefetchingOffers && !documentRequirements);

  return {
    isLoadingOffersAndRelatedData,
    isLoadingPage,
    isSecurityCheckRequired,
    signupError,
    documentRequirements,
    requestedDuration,
    requestedAmount,
  };
};
